import React, { useRef, useEffect, memo } from "react";
import { Container } from "@pixi/react";
import { useDispatch, useSelector } from "react-redux";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import FreeSpinSceneTransitionController from "./FreeSpinSceneTransitionController";
import { safeInit } from "../../../../utilities";

import { selectFreeSpinTransitionActive } from "../../../../State/selectors";
import { setFreeSpinTransitionMidpoint } from "../../../../State/actions";

const FreeSpinSceneTransition = () => {
  const dispatch = useDispatch();
  const controllerRef = useRef(null);
  const containerRef = useRef(null);
  const { symbolWidth, symbolHeight, dimensions, dividerDimensions, device, orientation } =
    useDimensions();

  const freeSpinTransitionActive = useSelector(selectFreeSpinTransitionActive);

  // Initialize controller only once
  useEffect(() => {
    if (containerRef.current && !controllerRef.current) {
      safeInit(() => {
        controllerRef.current = new FreeSpinSceneTransitionController(
          containerRef.current,
          symbolWidth,
          symbolHeight,
          dimensions,
          dividerDimensions,
          device,
          orientation,
          dispatch
        );

        // Wire midpoint callback — dispatches Redux state for ReelBackDecoration
        controllerRef.current.onMidpoint = () => {
          dispatch(setFreeSpinTransitionMidpoint(true));
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle dimension changes
  useEffect(() => {
    if (controllerRef.current) {
      controllerRef.current.resize(
        symbolWidth,
        symbolHeight,
        dimensions,
        dividerDimensions,
        device,
        orientation
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbolHeight]);

  // Play or stop transition animation
  useEffect(() => {
    if (freeSpinTransitionActive && controllerRef.current) {
      controllerRef.current.playAnimation();
    } else if (!freeSpinTransitionActive && controllerRef.current) {
      controllerRef.current.stopTransition();
      // Reset midpoint flag when transition ends
      dispatch(setFreeSpinTransitionMidpoint(false));
    }
  }, [freeSpinTransitionActive, dispatch]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (controllerRef.current) {
        controllerRef.current.cleanup();
      }
    };
  }, []);

  return (
    <Container
      name="free_spin_scene_transition"
      x={0}
      y={0}
      zIndex={8}
      sortableChildren
      ref={containerRef}
    />
  );
};

export default memo(FreeSpinSceneTransition);
